import { render } from "./LoadingSvg.vue?vue&type=template&id=56330be4"
const script = {}

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__